// extracted by mini-css-extract-plugin
module.exports = {"accepted":"ConsentStatus_accepted__1ymA4","declined":"ConsentStatus_declined__2jdSF","withdrawn":"ConsentStatus_withdrawn__2qDl5"};